import { BusinessContext } from '@periscopes/general/context';
import { FieldInformation } from './FieldInformation';
import { FieldTags } from './FieldTags';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { When } from 'react-if';
import { FormulaFieldMetaData, LookupFieldMetaData } from '@periscopes/general/fields';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useEffect } from 'react';
import { usePeriscopeMetadata, useSonarObjectReference, useUpdateSonarObjectReference } from '@hooks';
export const FieldMetadataTab = ({ sonarObjectId, index }) => {
    var _a, _b;
    const tagIds = (_b = (_a = useSonarObjectReference(sonarObjectId)) === null || _a === void 0 ? void 0 : _a.tagIds) !== null && _b !== void 0 ? _b : [];
    const { update } = useUpdateSonarObjectReference();
    const { loading, metadata } = usePeriscopeMetadata(sonarObjectId, SonarObjectType.SalesforceField);
    useEffect(() => {
        if (metadata && sonarObjectId) {
            update({
                internalName: metadata.internalName,
                linkedIntegrations: metadata.linkedIntegrations,
                parentDisplayName: metadata.parentDisplayName,
                parentInternalName: metadata.parentInternalName,
                parentSonarObjectId: metadata.parentSonarObjectId,
                rawSalesforceType: metadata.rawSalesforceType,
                salesforce: {
                    complianceCategory: metadata.complianceCategory,
                    dataSensitivityLevelId: metadata.dataSensitivityLevelId,
                    fieldUsageId: metadata.fieldUsageId,
                    helpText: metadata.helpText,
                    isCustom: metadata.isCustom
                },
                sonarObjectId
            });
            if (metadata.parentSonarObjectId) {
                update({
                    displayName: metadata.parentDisplayName,
                    sonarObjectId: metadata.parentSonarObjectId
                });
            }
        }
    }, [metadata, sonarObjectId, update]);
    if (!metadata || loading) {
        return React.createElement(LoadingSpinner, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(FieldInformation, { sonarObjectId: sonarObjectId }),
        React.createElement(FormulaFieldMetaData, { formulaFieldMetaData: metadata.formulaFieldReferences, index: index }),
        React.createElement(LookupFieldMetaData, { index: index, lookupEntities: metadata.lookupEntities }),
        React.createElement(When, { condition: tagIds.length },
            React.createElement(FieldTags, { index: index, tagIds: tagIds })),
        React.createElement(BusinessContext, { sonarObjectId: sonarObjectId })));
};
